import React from 'react'; 
import './index.css'; 
import About from './Components/About';
import Experience from './Components/Experience'; 
import Nav from './Components/Menu'; 
import Home from './Components/Home'; 
import Portfolio from './Components/Portfolio'; 


import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

function App (){
  return (
    <Router>
      <div >
        <Nav/>
        <Switch>
          <Route path="/" exact component={About}/>
          <Route path="/about" component={About}/>
          <Route path="/experience" component={Experience}/>
          <Route path="/portfolio" component={Portfolio}/>
        </Switch>
      </div>
    </Router>
  )
}


export default App; 